import axios from 'axios'

export function fetchCounts ({ commit, getters }, params = {}) {
  return axios.get('/api/count', { params })
    .then(response => response.data)
    .then(result => { commit('setCounts', result) })
}
